<template>
  <v-card
    :color="!plan.best ? 'transparent elevation-0' : undefined"
    :light="plan.best"
    class="v-card--plan mx-auto pt-3 pb-4 px-2 text-center"
    max-width="100%"
  >
    <div
      class="text-body-2 text-uppercase grey--text"
      v-text="plan.heading"
    />

    <v-avatar
      size="130"
    >
      <v-icon
        :color="!plan.best ? undefined : 'success'"
        size="64"
        v-text="plan.icon"
      />
    </v-avatar>

    <h2
      class="text-h3 font-weight-light"
      v-text="plan.title"
    />
    <h2
      class="text-h3 font-weight-light"
      v-text="'$' + plan.cost"
    />
    <v-card-text
      class="text-body-1 font-weight-light pa-1"
      v-text="plan.text"
    />
    <v-list-item
      v-for="(item, index) in plan.itemList"
      :key="index"
    >
      <v-list-item-content>
        <v-list-item-title>{{ item.text }}</v-list-item-title>
      </v-list-item-content>
    </v-list-item>
  </v-card>
</template>

<script>

  export default {
    name: 'PagesPlanCardReduced',

    props: {
      plan: {
        type: Object,
        default: () => ({
          best: false,
          heading: undefined,
          icon: undefined,
          title: undefined,
          text: undefined,
          cost: undefined,
        }),
      },
    },

    data () {
      return {
        itemData: {
          quantity: '1',
          installments: '1',
          trialDays: '15',
          immediatePayment: true,
          extra1: 'Extra 1',
          extra2: 'Extra 2',
          customer: {
            fullName: 'Pedro Perez',
            email: 'pperez@payulatam.com',
            creditCards: [
              {
                name: 'Pedro Perez',
                document: '101010123',
                number: '4242424242424242',
                expMonth: '01',
                expYear: '2018',
                type: 'VISA',
                address: {
                  line1: 'Address Name',
                  line2: '17 25',
                  line3: 'Of 301',
                  postalCode: '00000',
                  city: 'City Name',
                  state: 'State Name',
                  country: 'CO',
                  phone: '300300300',
                },
              },
            ],
          },
          plan: {
            planCode: 'sample-plan-code-001',
            description: 'Sample Plan 001',
            accountId: '512321',
            intervalCount: '1',
            interval: 'MONTH',
            maxPaymentsAllowed: '12',
            maxPaymentAttempts: '3',
            paymentAttemptsDelay: '1',
            maxPendingPayments: '1',
            trialDays: '30',
            additionalValues: [
              {
                name: 'PLAN_TAX',
                value: 1600,
                currency: 'COP',
              },
              {
                name: 'PLAN_VALUE',
                value: 10000,
                currency: 'COP',
              },
              {
                name: 'PLAN_TAX_RETURN_BASE',
                value: 8400,
                currency: 'COP',
              },
            ],
          },
          deliveryAddress: {
            line1: 'Address Name',
            line2: '17 25',
            line3: 'Of 301',
            postalCode: '00000',
            city: 'City Name',
            state: 'State Name',
            country: 'CO',
            phone: '300300300',
          },
          notifyUrl: 'http://www.test.com/confirmation',
        },
      }
    },
    computed: {
      isAuth () {
        return !!this.$store.state.users.user
      },
    },

    methods: {
      queuePlan (plan) {
        const vm = this
        // la funcion debe:
        // guardar el plan que escogio el usuario en el storage
        vm.$store.dispatch('subscriptions/selectPlan', plan).then(function () {
          // si el usuario no esta registrado, mandarlo a la pagina de registro
          if (vm.isAuth) {
            // console.log(plan)
            vm.$router.push(
              {
                name: 'Planner',
                params:
                  {
                    plan: plan,
                  },
              },
            )
            // vm.planes()
          } else {
            vm.$router.replace('/pages/register').catch(err => {
              console.log(err)
            })
          }
        })
        // una vez el usuario se registra, llena los datos, y cierra el modal, se despliega otro modal para seguir con el proceso del plan que escogio
        // si el usuario ya esta registrado, desplegar el modal para seguir el proceso con la pasarela de pago.
      },
      // planes () {
      //   const vm = this
      //   axios.post('https://api.payulatam.com/payments-api/rest/v4.9/subscriptions/', vm.itemData).then(res => {
      //     // console.log(res)
      //   }).catch(e => {
      //     // console.log(e)
      //   })
      // },
    },

  }
</script>

<style lang="sass">
  .v-card--plan
    .v-avatar
      border-radius: 50%
      border: 1px solid #E5E5E5
</style>
